<form [formGroup]="templateForm" (ngSubmit)="onSave()">
    <r1-compass-lib-instructions headerText="Criteria">
        Set the desired selection criteria by choosing the database field, comparison logic and match value to narrow
        down your record selection. At a minimum, the green rows are required to be populated. The wizard allows you to
        match using both basic (e.g., a single match field) and complex query logic (e.g., combining various criteria).
        To add additional criteria, simply click the "Add" button. To remove a criteria, click the (trash) icon. For
        additional information, see the user guide.
    </r1-compass-lib-instructions>
    <div class="criteria-list-container">
        <div class="criteria-list">
            @for (criterionFormGroup of templateForm.controls.selectionCriteria.controls; track $index) {
                @if (criterionFormGroup.controls.type.value === 'generic') {
                    <r1-compass-app-generic-selection-criterion
                        [index]="$index"
                        [tables]="genericCriteriaTables()"
                        [requiredTableName]="$index === 0 ? divisionConfiguredTable()?.name : undefined"
                        [requiredDatamartFieldName]="$index === 0 ? datamartRequiredField()?.name : undefined"
                        [criterionForm]="criterionFormGroup.controls.data | r1NarrowWideFormTypes"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        (deleteCriterion)="onDeleteCriterion($event)" />
                } @else if (criterionFormGroup.controls.type.value === 'model') {
                    <r1-compass-app-generic-selection-criterion
                        [index]="$index"
                        [tables]="modelTables()"
                        [requiredTableName]="$index === 0 ? divisionConfiguredTable()?.name : undefined"
                        [requiredDatamartFieldName]="$index === 0 ? datamartRequiredField()?.name : undefined"
                        [criterionForm]="criterionFormGroup.controls.data | r1NarrowWideFormTypes"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        (deleteCriterion)="onDeleteCriterion($event)" />
                } @else if (criterionFormGroup.controls.type.value === 'web search') {
                    <r1-compass-app-web-search-criterion
                        [criterionForm]="criterionFormGroup.controls.data | r1NarrowWideFormTypes"
                        [index]="$index"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        (deleteCriterion)="onDeleteCriterion($event)" />
                } @else if (criterionFormGroup.controls.type.value === 'web activity') {
                    <r1-compass-app-web-activity-criterion
                        [criterionForm]="criterionFormGroup.controls.data | r1NarrowWideFormTypes"
                        [index]="$index"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        [cmtLevels]="webActivityCmtLevels()"
                        [webActivityPeriodFields]="webActivityPeriodFields()"
                        (deleteCriterion)="onDeleteCriterion($event)" />
                } @else if (criterionFormGroup.controls.type.value === 'sales history') {
                    <r1-compass-app-sales-history-criterion
                        [criterionForm]="criterionFormGroup.controls.data | r1NarrowWideFormTypes"
                        [index]="$index"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        [cmtLevels]="salesHistoryCmtLevels()"
                        [selfManufacturedOptions]="selfManufacturedOptions()"
                        [sspOptions]="sspOptions()"
                        [privateLabelOptions]="privateLabelOptions()"
                        [channels]="salesHistoryChannels()"
                        [metrics]="salesHistoryMetricFields()"
                        (deleteCriterion)="onDeleteCriterion($event)" />
                }
            }
        </div>
        <div class="criteria-list-footer">
            <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" type="button">+Add</button>
            <mat-menu #menu="matMenu">
                @if (allowedSelectionCriteria().includes('Generic Criteria')) {
                    <button mat-menu-item (click)="onAddCriteria('generic')" type="button">Generic</button>
                }
                @if (allowedSelectionCriteria().includes('Model Criteria')) {
                    <button mat-menu-item (click)="onAddCriteria('model')" type="button">Model</button>
                }
                @if (allowedSelectionCriteria().includes('Sales History Criteria')) {
                    <button mat-menu-item (click)="onAddCriteria('sales history')" type="button">Sales History</button>
                }
                @if (allowedSelectionCriteria().includes('Web Activity Criteria')) {
                    <button mat-menu-item (click)="onAddCriteria('web activity')" type="button">Web Activity</button>
                }
                @if (allowedSelectionCriteria().includes('Web Search Criteria')) {
                    <button mat-menu-item (click)="onAddCriteria('web search')" type="button">Web Search</button>
                }
            </mat-menu>
        </div>
    </div>
    <r1-compass-lib-divider />
    <r1-compass-lib-grouping-logic-complex [groupingLogicForm]="templateForm.controls.groupingLogic" />
    <div class="component-footer">
        <button mat-raised-button color="primary" [disabled]="disableSave()" type="submit">Save</button>
    </div>
</form>
